<template>
  <v-sheet color="grey lighten-5" class="pfe-panel d-flex flex-column overflow-hidden">

    <div class="pa-2 pb-1 pfe-panel-header">
      <v-text-field
        v-model="search"
        dense hide-details outlined
        :placeholder="$t('Search')"
        prepend-inner-icon="mdi-magnify"
        class="text-caption"
      />
      <div class="d-flex justify-space-around mt-1">
        <v-btn icon x-small @click="$emit('navigate', -Infinity)"><v-icon x-small>mdi-page-first</v-icon></v-btn>
        <v-btn icon x-small @click="$emit('navigate', -1)"><v-icon x-small>mdi-chevron-left</v-icon></v-btn>
        <v-btn icon x-small @click="$emit('navigate', 1)"><v-icon x-small>mdi-chevron-right</v-icon></v-btn>
        <v-btn icon x-small @click="$emit('navigate', Infinity)"><v-icon x-small>mdi-page-last</v-icon></v-btn>
      </div>
    </div>

    <v-list dense color="transparent" class="flex-grow-1 overflow-y-auto py-0">
      <template v-for="doc in filteredDocuments">
        <v-list-group
          :key="`doc-${doc.id}`"
          v-model="doc.expanded"
          no-action
          color="primary"
          :class="{ 'pfe-doc-merged': doc.merged }"
        >
          <template v-slot:activator>
            <v-list-item-icon class="mr-2 my-auto">
              <v-icon small :color="docColor(doc)">mdi-file-pdf-box</v-icon>
            </v-list-item-icon>
            <v-list-item-content @click="doc.pages.length && $emit('select-page', doc, doc.pages[0])">
              <v-list-item-title class="text-caption font-weight-medium text-truncate">
                {{ doc.name }}
                <v-chip v-if="doc.merged" x-small color="grey lighten-2" text-color="grey darken-1" class="ml-1">{{ $t('Site.PdfManipulation.Merged') }}</v-chip>
              </v-list-item-title>
              <v-list-item-subtitle class="text-caption">
                {{ doc.pages.length }} {{ $t('Site.PdfManipulation.Pages') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="page in doc.pages"
            :key="`page-${doc.id}-${page.index}`"
            dense
            class="pl-8"
            :input-value="isPageSelected(doc, page)"
            active-class="pfe-page-active primary--text"
            @click="$emit('select-page', doc, page)"
            @contextmenu.prevent="$emit('context-menu', $event, doc, page)"
          >
            <v-list-item-icon class="mr-2 my-auto">
              <v-icon x-small :color="page.sourceDocId !== doc.id ? 'orange darken-1' : docColor(doc)">
                {{ page.sourceDocId !== doc.id ? 'mdi-file-move-outline' : 'mdi-file-outline' }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-caption">{{ $t('Page') }} {{ page.index }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-divider :key="`div-${doc.id}`" />
      </template>

      <div v-if="loading" class="d-flex justify-center pa-6">
        <v-progress-circular indeterminate size="24" color="primary" />
      </div>
    </v-list>
  </v-sheet>
</template>

<script>
export default {
    name: 'PdfDocumentPanel',
    props: {
        documents: { type: Array, required: true },
        selectedPage: { type: Object, default: null },
        docColors: { type: Array, required: true },
        loading: { type: Boolean, default: false },
    },
    data() {
        return { search: '' };
    },
    computed: {
        filteredDocuments() {
            if (!this.search) return this.documents;
            const q = this.search.toLowerCase();
            return this.documents.filter(function(d) { return d.name.toLowerCase().includes(q); });
        },
    },
    methods: {
        docColor(doc) {
            const idx = this.documents.indexOf(doc);
            return this.docColors[idx % this.docColors.length];
        },
        isPageSelected(doc, page) {
            return this.selectedPage && this.selectedPage.docId === doc.id && this.selectedPage.page === page;
        },
    },
};
</script>

<style scoped>
.pfe-panel {
  width: 100%;
  height: 100%;
  border-right: 1px solid #e0e0e0;
}
.pfe-panel-header {
  border-bottom: 1px solid #e0e0e0;
}
.pfe-page-active {
  background: rgba(25, 118, 210, 0.08) !important;
}
.pfe-doc-merged {
  opacity: 0.5;
}
</style>
